import requests from "./httpService";

const AuthService = {
  loginAdmin(body) {
    return requests.post(`/admin/login`, body);
  },
  // forgetPassword(body) {
  //   return requests.put("/admin/forget-password", body);
  // },
  resetPassword(body) {
    return requests.post("/user/reset-password", body);
  },
  forgetPassword(body) {
    return requests.post("/user/forgot-password", body);
  },

  verifyEmail(body) {
    return requests.post("/user/verify-email", body);
  }
};

export default AuthService;
